import CountUp from "react-countup";

function NumCard({ amount, text, colour, className = "", width = "w-auto", height = "h-[14rem]", link=""}) {
  return (
    <a href={link}>
      <div
        className={`${className} ${width} ${height} bg-white px-2 flex flex-col justify-center items-center border-b-[20px] border-b-[${colour}] rounded-2xl outline-2 outline-gray-200 text-[${colour}] hover:scale-[1.05] transition-all duration-300 cursor-pointer shadow-[0_3px_10px_rgb(0,0,0,0.2)]`}
      >
        <span className="num-text text-5xl/[1.25] font-bold">
          <CountUp end={amount} />
        </span>
        <p className="text-xl font-semibold">{text}</p>
      </div>
    </a>
  );
}

export default NumCard;
